import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "El rincón de mis palabras";
// Marca unificada para <title> y og:site_name.
const SITE_BRAND = "El rincón de mis palabras — Javi Lobo";

export function Seo({ title, description, image, url, type = "website", jsonLd }) {
  const pageTitle = title ? `${title} · ${SITE_BRAND}` : SITE_BRAND;
  const ogTitle = title || SITE_NAME;
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;

  // react-helmet-async no promueve de forma fiable <script> inline al <head>,
  // así que inyectamos el JSON-LD manualmente en document.head y lo limpiamos al desmontar.
  useEffect(() => {
    if (!jsonLdStr) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo-jsonld", "true");
    el.textContent = jsonLdStr;
    document.head.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [jsonLdStr]);

  return (
    <Helmet prioritizeSeoTags>
      <title>{pageTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      {url ? <link rel="canonical" href={url} /> : null}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_BRAND} />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:title" content={ogTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      {url ? <meta property="og:url" content={url} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={ogTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
    </Helmet>
  );
}
